// Chart theme colors
export const chartColors = {
  primary: "#0ea5e9",
  secondary: "#f97316", 
  accent: "#10b981", 
  muted: "#94a3b8",
  background: "#f8fafc", 
  foreground: "#334155", 
  grid: "#e2e8f0", 

  series: [
    "#0ea5e9", 
    "#f97316", 
    "#10b981", 
    "#8b5cf6", 
    "#ec4899", 
    "#f59e0b", 
    "#ef4444", 
    "#06b6d4", 
    "#6366f1", 
    "#84cc16", 
  ],
};

export const generateRandomData = (
  points: number = 5,
  max: number = 100,
  categories?: string[],
) => {
  return Array(points)
    .fill(0)
    .map((_, i) => ({
      name: categories ? categories[i % categories.length] : `Item ${i + 1}`,
      value: Math.floor(Math.random() * max) + 10,
    }));
};

export const generateMultiSeriesData = (
  series: number = 2,
  points: number = 5,
  max: number = 100,
  categories?: string[],
) => {
  const seriesNames = [
    "Series A",
    "Series B",
    "Series C",
    "Series D",
    "Series E",
  ];
  return Array(series)
    .fill(0)
    .map((_, i) => ({
      name: seriesNames[i],
      data: generateRandomData(points, max, categories),
    }));
};

export interface ChartDataPoint {
  name: string;
  value: number;
  [key: string]: string | number | boolean | null | undefined;
}

export interface ChartSeries {
  name: string;
  data: ChartDataPoint[];
}

export interface BaseChartProps {
  data?: ChartDataPoint[];
  series?: ChartSeries[];
  title?: string;
  subtitle?: string;
  height?: number;
  width?: number | string;
  className?: string;
  colors?: string[];
  showLegend?: boolean;
  showTooltip?: boolean;
  showGrid?: boolean;
  animate?: boolean;
  legendPosition?: "top" | "right" | "bottom" | "left";
}

export const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
};

export const defaultResponsiveConfig = {
  width: "100%",
  height: "100%",
  minWidth: 200,
  minHeight: 100,
};